var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-excel-mapper", {
    attrs: {
      service: _vm.ProductService.excelMapperService,
      "allowed-output-headers": _vm.cols,
    },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
      file: _vm.onExcelMapperFile,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }